import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { config } from '@/config.ts';

const MUTATION_KEY = ['auth', 'two-fa', 'login'];

export const useMutationTwoFaLogin = () => {
	return useMutation({
		mutationKey: MUTATION_KEY,
		mutationFn: async ({ id, password }: { id: string; password: string }) => {
			try {
				const externalResponse = await axios.post(
					`${config.GR8_URL}/login`,
					{
						login: id,
						password: password
					},
					{
						headers: {
							'X-API-KEY': config.API_KEY,
							'Content-Type': 'application/json',
							'X-TwoFA-Ver': 1
						}
					}
				);

				if (externalResponse?.data?.twoFASessionKey) {
					return {
						twoFASessionKey: externalResponse.data.twoFASessionKey
					};
				} else {
					throw new Error('Account info-page not found in external response');
				}
			} catch (error) {
				console.error('Login mutation error:', error);
				throw error;
			}
		},
		onSuccess: () => {
			console.log('success');
		},
		onError: error => {
			console.error('Error during login mutation:', error);
		}
	});
};
